import { gql } from '@apollo/client';

export const DisableTotpEnableEmail = gql`
  mutation DisableTotpEnableEmail($immutableId: String!) {
    disableTotpEnableEmail(immutableId: $immutableId)
  }
`;
